import { useMemo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    fetchDatasets,
    gridDatasetSelector,
    createFetchGridDataset
} from '@libs/datasets';
import { makeSideEffectCallback } from '@libs/makeContext';

import { DAILY_ALL_ATTENDANCE } from 'timeAndAttendance/redux.datasets';
import { DOMAIN_NAME } from 'timeAndAttendance/common';
import { DailyTimesheetsProvider } from './useDailyTimesheets';
import Filters from './Filters/';
import DataTable from './DataTable';
import Pagination from './Pagination';

const TimesheetsDailyView = () => {
    const { data, currentPage, totalPages } = useSelector((state) =>
        gridDatasetSelector(state, DOMAIN_NAME, DAILY_ALL_ATTENDANCE)
    );
    const dispatch = useDispatch();
    const fetchAllAttendance = useCallback(
        () => dispatch(fetchDatasets(DAILY_ALL_ATTENDANCE)),
        [dispatch]
    );
    const fetchGridDailyDataset = useCallback(
        (payload) =>
            dispatch(
                createFetchGridDataset(
                    DOMAIN_NAME,
                    DAILY_ALL_ATTENDANCE
                )(payload)
            ),
        [dispatch]
    );

    const initialize = useCallback(
        (state) => ({
            ...state,
            data,
            totalPages,
            currentPage
        }),
        [currentPage, totalPages, data]
    );

    const middlewareProps = useMemo(
        () => ({
            fetchData: makeSideEffectCallback(fetchGridDailyDataset)
        }),
        [fetchGridDailyDataset]
    );

    useEffect(() => {
        fetchAllAttendance();
    }, []);

    return (
        <DailyTimesheetsProvider
            initialize={initialize}
            middlewareProps={middlewareProps}
        >
            <Filters />
            <DataTable />
            <Pagination />
        </DailyTimesheetsProvider>
    );
};

export default TimesheetsDailyView;
